/**
 * persistent-purchase-controls.js
 * NiHealth — Persistent Purchase Controls
 */

(function () {
  'use strict';

  if (!document.body.classList.contains('s8-product-page')) return;

  var root = document.querySelector('.ppc-root');
  if (!root) return;
  document.body.appendChild(root);

  var FORM_ID    = root.dataset.ppcFormId;
  var QTY_ID     = root.dataset.ppcQtyId;
  var SECTION_ID = root.dataset.sectionId;

  var PRODUCT_FALLBACK_SRC = root.dataset.productFallbackSrc
    ? root.dataset.productFallbackSrc.trim()
    : '';
  var PRODUCT_FALLBACK_ALT = root.dataset.productFallbackAlt
    ? root.dataset.productFallbackAlt
    : '';

  if (!FORM_ID || !QTY_ID || !SECTION_ID) {
    console.error('[PPC] Missing required data attributes. Aborted.');
    return;
  }

  var originalForm = document.getElementById(FORM_ID);
  var originalQty  = document.getElementById(QTY_ID);

  if (!originalForm) {
    console.error('[PPC] Product form not found:', FORM_ID);
    return;
  }
  if (!originalQty) {
    console.error('[PPC] Quantity input not found:', QTY_ID);
    return;
  }

  var productSection = document.getElementById('ProductInfo-' + SECTION_ID);
  if (!productSection) {
    console.error('[PPC] Scoped product section not found: ProductInfo-' + SECTION_ID + '. Price fallback disabled.');
  }

  var ppcQtyInputs = Array.from(root.querySelectorAll('.ppc-qty-input'));
  var ppcMinusBtns = Array.from(root.querySelectorAll('.ppc-qty-minus'));
  var ppcPlusBtns  = Array.from(root.querySelectorAll('.ppc-qty-plus'));
  var ppcAtcBtns   = Array.from(root.querySelectorAll('.ppc-atc-btn'));
  var mobileBars   = Array.from(root.querySelectorAll('.ppc-mobile'));
  var priceEls     = Array.from(root.querySelectorAll('.ppc-mobile__price'));
  var thumbEls     = Array.from(root.querySelectorAll('.ppc-mobile__thumb'));

  var requestInFlight = false;
  var unsubUpdate     = null;
  var unsubError      = null;
  var safetyTimer     = null;
  var successTimer    = null;

  function getAuthButton() {
    return originalForm.querySelector('[type="submit"]');
  }

  function toFiniteNumber(value) {
    var n = Number(value);
    return Number.isFinite(n) ? n : null;
  }

  function normalizeNumber(value) {
    return Number(Number(value).toFixed(12));
  }

  function clearSuccessTimer() {
    if (successTimer !== null) {
      clearTimeout(successTimer);
      successTimer = null;
    }
  }

  function getQuantityRules() {
    var min = toFiniteNumber(originalQty.getAttribute('min'));
    if (min === null) min = 1;

    var maxAttr = originalQty.getAttribute('max');
    var max = null;
    if (maxAttr !== null && maxAttr !== '') {
      max = toFiniteNumber(maxAttr);
      if (max !== null && max < min) max = min;
    }

    var increment = toFiniteNumber(originalQty.getAttribute('step'));
    if (increment === null || increment <= 0) increment = 1;

    return { min: min, max: max, increment: increment };
  }

  function mirrorQtyRules() {
    var authBtn = getAuthButton();
    var purchasingDisabled = originalQty.disabled || !authBtn || authBtn.disabled;

    var rules = getQuantityRules();
    var originalValue = toFiniteNumber(originalQty.value);
    if (originalValue === null) originalValue = rules.min;

    var mirroredValue = originalQty.value;
    if (mirroredValue === null || mirroredValue === undefined || mirroredValue === '') {
      mirroredValue = String(originalValue);
    }

    ppcQtyInputs.forEach(function (input) {
      input.value = mirroredValue;
      input.min   = String(rules.min);
      input.step  = String(rules.increment);
      if (rules.max !== null) {
        input.max = String(rules.max);
      } else {
        input.removeAttribute('max');
      }
      input.disabled = purchasingDisabled;
    });

    if (purchasingDisabled) {
      ppcMinusBtns.forEach(function (btn) { btn.disabled = true; });
      ppcPlusBtns.forEach(function (btn)  { btn.disabled = true; });
      return;
    }

    ppcMinusBtns.forEach(function (btn) {
      btn.disabled = originalValue <= rules.min;
    });
    ppcPlusBtns.forEach(function (btn) {
      btn.disabled = rules.max !== null && originalValue >= rules.max;
    });
  }

  function getAuthLabel(authBtn) {
    var children = Array.from(authBtn.children);
    var labelSpan = children.find(function (child) {
      return child.tagName === 'SPAN';
    });
    if (labelSpan) {
      var text = labelSpan.textContent.trim();
      if (text) return text;
    }
    return authBtn.textContent.trim();
  }

  function mirrorAtcState() {
    var authBtn = getAuthButton();
    if (!authBtn) {
      console.error('[PPC] ATC button not found in form:', FORM_ID);
      ppcAtcBtns.forEach(function (btn) { btn.disabled = true; });
      return;
    }
    var isDisabled = authBtn.disabled;
    var authLabel  = getAuthLabel(authBtn);
    ppcAtcBtns.forEach(function (btn) {
      if (!btn.classList.contains('ppc-atc-btn--loading')) {
        btn.disabled    = isDisabled;
        btn.textContent = authLabel;
      }
    });
  }

  function mirrorPrice(variantPrice) {
    var formatted = null;

    if (
      typeof Shopify !== 'undefined' &&
      typeof Shopify.formatMoney === 'function' &&
      typeof Shopify.money_format === 'string' &&
      Shopify.money_format.length > 0 &&
      variantPrice !== null &&
      variantPrice !== undefined
    ) {
      formatted = Shopify.formatMoney(variantPrice, Shopify.money_format);
    }

    if (!formatted && productSection) {
      var containers = [
        { sel: '.price__regular', item: '.price-item--regular' },
        { sel: '.price__sale',    item: '.price-item--sale'    }
      ];
      for (var i = 0; i < containers.length; i += 1) {
        var containerEl = productSection.querySelector(containers[i].sel);
        if (!containerEl) continue;
        if (containerEl.getClientRects().length === 0) continue;
        var itemEl = containerEl.querySelector(containers[i].item);
        if (!itemEl) continue;
        var text = itemEl.textContent.trim();
        if (text) { formatted = text; break; }
      }
    }

    if (formatted !== null && formatted !== '') {
      priceEls.forEach(function (el) { el.textContent = formatted; });
    }
  }

  function mirrorThumb(src, alt) {
    if (!src) return;
    thumbEls.forEach(function (img) {
      img.src = src;
      img.alt = alt || '';
    });
  }

  function mirrorVariantThumb(variant) {
    var variantImage = variant && variant.featured_image ? variant.featured_image : null;
    if (variantImage && variantImage.src) {
      mirrorThumb(variantImage.src, variantImage.alt || '');
      return;
    }
    if (PRODUCT_FALLBACK_SRC) {
      mirrorThumb(PRODUCT_FALLBACK_SRC, PRODUCT_FALLBACK_ALT);
    }
  }

  function syncAll() {
    mirrorQtyRules();
    mirrorAtcState();
  }

  // Plus / minus buttons
  ppcMinusBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      originalQty.stepDown();
      originalQty.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  ppcPlusBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      originalQty.stepUp();
      originalQty.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  // Typed quantity input
  ppcQtyInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      var rawMin = toFiniteNumber(originalQty.getAttribute('min'));
      var min    = rawMin !== null ? rawMin : 1;

      var maxAttr = originalQty.getAttribute('max');
      var max = null;
      if (maxAttr !== null && maxAttr !== '') {
        var parsedMax = toFiniteNumber(maxAttr);
        if (parsedMax !== null) max = parsedMax < min ? min : parsedMax;
      }

      var rawIncrement = toFiniteNumber(originalQty.getAttribute('step'));
      var increment    = (rawIncrement !== null && rawIncrement > 0) ? rawIncrement : 1;

      var enteredValue = toFiniteNumber(input.value);
      var value        = enteredValue !== null ? enteredValue : min;

      value = Math.max(value, min);
      if (max !== null) value = Math.min(value, max);

      var stepCount = Math.round((value - min) / increment);
      value = normalizeNumber(min + stepCount * increment);

      if (value < min) value = min;
      if (max !== null && value > max) {
        var maxStepCount = Math.floor((max - min) / increment);
        value = normalizeNumber(min + maxStepCount * increment);
      }
      if (value < min) value = min;
      if (max !== null && value > max) value = max;

      originalQty.value = String(value);
      originalQty.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  originalQty.addEventListener('change', function () {
    mirrorQtyRules();
  });

  // Request state cleanup
  function clearRequestState() {
    if (typeof unsubUpdate === 'function') { unsubUpdate(); unsubUpdate = null; }
    if (typeof unsubError  === 'function') { unsubError();  unsubError  = null; }
    if (safetyTimer !== null) { clearTimeout(safetyTimer); safetyTimer = null; }
  }

  function cleanup(success) {
    clearSuccessTimer();
    clearRequestState();
    requestInFlight = false;

    ppcAtcBtns.forEach(function (btn) {
      btn.classList.remove('ppc-atc-btn--loading');
      btn.removeAttribute('aria-disabled');
    });

    if (!success) {
      mirrorAtcState();
      mirrorQtyRules();
      return;
    }

    ppcAtcBtns.forEach(function (btn) { btn.textContent = '✓ Added'; });
    successTimer = setTimeout(function () {
      successTimer = null;
      mirrorAtcState();
      mirrorQtyRules();
    }, 1500);
  }

  // ATC click handler
  ppcAtcBtns.forEach(function (btn) {
    btn.addEventListener('click', function (event) {
      if (requestInFlight || btn.disabled) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      clearSuccessTimer();
      clearRequestState();
      requestInFlight = true;

      ppcAtcBtns.forEach(function (b) {
        b.classList.add('ppc-atc-btn--loading');
        b.setAttribute('aria-disabled', 'true');
      });

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        unsubUpdate = subscribe(PUB_SUB_EVENTS.cartUpdate, function () { cleanup(true); });
        unsubError  = subscribe(PUB_SUB_EVENTS.cartError,  function () { cleanup(false); });
      }

      safetyTimer = setTimeout(function () { cleanup(false); }, 8000);
    });
  });

  // Cart drawer observer
  var cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    new MutationObserver(function () {
      var isOpen = cartDrawer.classList.contains('active');
      mobileBars.forEach(function (bar) {
        bar.classList.toggle('ppc-mobile--hidden', isOpen);
      });
    }).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }

  // Variant change subscription
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (!event || !event.data || event.data.sectionId !== SECTION_ID) return;

      clearSuccessTimer();

      var variant = event.data.variant;
      setTimeout(function () {
        syncAll();
        if (variant && variant.price !== null && variant.price !== undefined) {
          mirrorPrice(variant.price);
        } else {
          mirrorPrice(null);
        }
        mirrorVariantThumb(variant);
      }, 0);
    });
  }

  syncAll();

})();
